function sorguDizgesi(sorgu) {
    const params = new URLSearchParams();
    if (sorgu.sayfa)
        params.set('sayfa', String(sorgu.sayfa));
    if (sorgu.boyut)
        params.set('boyut', String(sorgu.boyut));
    if (sorgu.arama)
        params.set('arama', sorgu.arama);
    if (sorgu.durum)
        params.set('durum', sorgu.durum);
    if (sorgu.noktaId)
        params.set('noktaId', sorgu.noktaId);
    if (sorgu.baslangicTen)
        params.set('baslangicTen', sorgu.baslangicTen);
    if (sorgu.baslangicAKadar)
        params.set('baslangicAKadar', sorgu.baslangicAKadar);
    const s = params.toString();
    return s ? `?${s}` : '';
}
export async function rezervasyonlariListele(istemci, sorgu = {}) {
    return istemci.istek(`/rezervasyonlar${sorguDizgesi(sorgu)}`);
}
export async function rezervasyonGetir(istemci, id) {
    return istemci.istek(`/rezervasyonlar/${id}`);
}
export async function rezervasyonIptal(istemci, id) {
    return istemci.istek(`/rezervasyonlar/${id}/iptal`, { method: 'POST' });
}
//# sourceMappingURL=rezervasyonlar.js.map